import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Lists of exercises you still have to sequence into 90 minutes', 'No clue where the peak goes or how to land it', 'No music guidance for each moment', 'One version for everyone, newcomers and regulars alike', 'Every week starts from a blank page again'];
const withIt = ['84 complete classes, opening circle to closing circle', 'Every moment timed, with formation and contact level', 'A music brief per phase: tempo, BPM range, character', 'Newcomer and deepening versions in every plan', 'Two pages and ten minutes for music, and you’re ready'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="topo-light w-full bg-paper" data-id="element-302" data-mp="2d8kdkalpsewx">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-303" data-mp="2d6g1349r27l1">
        <div className="text-center" data-id="element-304" data-mp="30xlgxjfowzvc">
          <p className="eyebrow text-ember-deep" data-id="element-305" data-mp="30wk53cquo9ck">
            Why this isn&apos;t another exercise list
          </p>
          <h2 id="vs-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-306" data-mp="1tf3e7vpg690i">
            Exercises vs{' '}
            <span className="text-forest" data-id="element-307" data-mp="234wg24zsf9rk">a shaped class</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-308" data-mp="23794n101widl">
            You already have exercises — from your training, your library and
            your own years in the circle. Finding exercises was never the hard
            part. Shaping them into a 90-minute vivencia that rises, deepens
            and returns at the right moment is. That’s the part this does for
            you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-paper-dark shadow-card" data-id="element-309" data-mp="2h4fnswoosj3c">
          <div className="bg-signal px-3.5 py-4 text-white sm:p-6" data-id="element-310" data-mp="rp7uni26misv">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-311" data-mp="mqwkt7bw08an">
              Exercises
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/85 sm:text-[11px]" data-id="element-312" data-mp="2mtpas64wwp4z">
              Lists &amp; libraries
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-313" data-mp="2ru3mpz9mwj8a">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-white/95 sm:text-sm" data-id="element-314" data-mp="2vvylox43ekiw">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-315" data-mp="35r8qfslvl60d">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-316" data-mp="3apa9idjax5bu" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-forest px-3.5 py-4 text-white sm:p-6" data-id="element-317" data-mp="3jin5xpgkqp2o">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-318" data-mp="3ojko421l3j46">
              Classes
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-ember sm:text-[11px]" data-id="element-319" data-mp="3ti4a22g6guwj">
              Vivencia Ready
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-320" data-mp="2hc1w16vdps4">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug sm:text-sm" data-id="element-321" data-mp="3tn3mym5sic82">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-moss" data-id="element-322" data-mp="3pnutzjikqidk">
                    <CheckIcon className="h-2.5 w-2.5 text-pine" aria-hidden="true" data-id="element-323" data-mp="q8hhcf8weg1w" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}